import {
  FilterMode,
  EditionContractPublisher_OrderBy,
  EditionContractPublisher,
  SortOrder,
  EditionContractPublisher_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const editionContractPublisherService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.editionContractPublisherOne({ id });
    return result.editionContractPublisherOne as EditionContractPublisher;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: EditionContractPublisher_OrderBy[] | null = null,
    filter: EditionContractPublisher_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EditionContractPublisher_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.editionContractPublisherListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.editionContractPublisherListWithOffset
    ) as EditionContractPublisher[];
    return { list, orderBy };
  },
};
